/**
 * Utility to convert text into a URL-friendly slug.
 */
export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD') // remove accents
    .replace(/[\u0300-\u036f]/g, '') // strip accent characters
    .replace(/[^a-z0-9 -]/g, '') // remove symbols
    .replace(/\s+/g, '-') // convert spaces to hyphens
    .replace(/-+/g, '-'); // collapse multiple hyphens
};
